module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular-f4769f.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.eot
 ** module id = 909
 ** module chunks = 2
 **/